import gql from 'graphql-tag'

export const barcodeLabelQuery = gql`
  query BarcodeLabel($accountId: Int!, $id: Int) {
    barcodeLabel(accountId: $accountId, id: $id) {
      id
      accountId
      barcodeSheetId
      name
      width
      height
      elements
      sheet {
        id
        accountId
        name
        size
        width
        height
        topMargin
        bottomMargin
        leftMargin
        rightMargin
        rows
        columns
        rowGutter
        columnGutter
        unit
      }
      barcodeSettings {
        id
        accountId
        barcodeLabelId
        name
        output
        barcodeType
        size
        labelFormat
        digits
        prefix
        startNumber
        startingCode
        dataSource
        entityId
        fieldId
        details
      }
    }
  }
`
